import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaPatient } from "../../../models/api";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const CaseMangerCard = (props: Props) => {
  const { patientId } = useParams<{ patientId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Patient.Root()}/update/${patientId}`}
      title="Case Manager"
      className="mb-3"
      isValidating={props.isValidating}
    >
      {props.isValidating ? (
        <TableCardPlaceholder rows={2} />
      ) : (
        <div>
          <table className="">
            <tr>
              <td className="p-2 pb-1 pe-2">Case manager name: </td>
              <td className="p-2 pb-1 ps-2">{props.data?.caseManager}</td>
            </tr>
            <tr>
              <td className="p-2 pb-1 pe-2">Case manager phone number: </td>
              <td className="p-2 pb-1 ps-2">
                {props.data?.caseManagerPhoneNumber}
              </td>
            </tr>
          </table>
        </div>
      )}
    </EditableCard>
  );
};
